<template lang="pug">
v-dialog(v-model="modal", width="80%", persistent)
  v-card
    v-card-title
      .headline.text-center(style="word-break: normal")
        | Please confirm that you’ve sent
        | all supporting documents
        | to the Home Office.

    v-card-actions
      v-spacer
      v-btn(text, @click="modal = false")
        | cancel
      v-btn(text, color="primary", @click="confirm")
        | confirm
</template>

<script>
export default {
  name: "OverviewDocumentsModal",

  props: {
    value: {
      type: Boolean,
      required: true,
    },

    caseID: {
      type: Number,
      required: true,
    },
  },

  methods: {
    confirm() {
      this.axios
        .get(`/employer/case/${this.caseID}/sponsorship/confirm_oa_docs`)
        .then(() => {
          this.$emit("success");
          this.modal = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },

  computed: {
    modal: {
      get() {
        return this.value;
      },

      set(v) {
        this.$emit("input", v);
      },
    },
  },
};
</script>